import * as actionList from '../actions/reporinvoiceactions';
import moment from 'moment';

const state = {
    search: '',
    page: 0,
    month: moment().month() + 1,
    year: moment().year(),
    invoicestatus: 0
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    month: state => state.month,
    year: state => state.year,
    invoicestatus: state => state.invoicestatus,
};

const actions = {
    [actionList.REPORTINVOICE_SEARCH]: ({ commit }, search) => {
        commit(actionList.REPORTINVOICE_SEARCH, search);
    },
    [actionList.REPORTINVOICE_PAGE]: ({ commit }, page) => {
        commit(actionList.REPORTINVOICE_PAGE, page);
    },
    [actionList.REPORTINVOICE_MONTH]: ({ commit }, month) => {
        commit(actionList.REPORTINVOICE_MONTH, month);
    },
    [actionList.REPORTINVOICE_YEAR]: ({ commit }, year) => {
        commit(actionList.REPORTINVOICE_YEAR, year);
    },
    [actionList.REPORTINVOICE_INVOICESTATUS]: ({ commit }, invoicestatus) => {
        commit(actionList.REPORTINVOICE_INVOICESTATUS, invoicestatus);
    },

};

const mutations = {
    [actionList.REPORTINVOICE_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionList.REPORTINVOICE_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionList.REPORTINVOICE_MONTH]: (state, month) => {
        state.page = 0;
        state.month = month;
    },
    [actionList.REPORTINVOICE_YEAR]: (state, year) => {
        state.page = 0;
        state.year = year;
    },
    [actionList.REPORTINVOICE_INVOICESTATUS]: (state, invoicestatus) => {
        state.page = 0;
        state.invoicestatus = invoicestatus;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};